// skipcq: JS-W1028, JS-0128
import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

/**
 * StickyButtonBar
 * A reusable sticky button bar component that matches the style used in the Beer tab.
 * Positioned at the top with sticky positioning to remain visible while scrolling.
 */
function StickyButtonBar({ children }) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: 1,
        position: 'sticky',

        // Account for appbar
        top: 48,

        zIndex: (theme) => theme.zIndex.appBar - 2,
        bgcolor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider',
        py: 1,
        px: 2,
        mb: 2
      }}>
      {children}
    </Box>
  );
}

StickyButtonBar.propTypes = {
  children: PropTypes.node.isRequired,
};

export default StickyButtonBar;
